import { Controller } from "stimulus";
import { loadHighcharts } from "../../util/load_package";
import { getActiveCurrency } from "../../util/currency";
import { buildChartConfig } from "../../template/charts/tokenomic_emission_chart";

let Highcharts;

export default class extends Controller {
  // Provided values, from data attributes
  dataJson = null;

  // Inferred values, not from data attributes
  chartInstance = null;
  activeCurrency = getActiveCurrency();

  async connect() {
    Highcharts = await loadHighcharts();
    this.renderChart();
  }

  renderChart() {
    this.dataJson = JSON.parse(this.element.dataset.dataJson);
    const chartConfig = buildChartConfig(this.dataJson, this.element, this.activeCurrency);
    this.chartInstance = Highcharts.StockChart(this.element.id, chartConfig);
  }
}
